var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"segment__chart"},[(_vm.hasDatasets)?_c('div',{staticClass:"chart__component"},[_c('line-chart',{attrs:{"datasets":_vm.datasets,"options":_vm.options,"stats":_vm.data.stats,"config":{
                  chartid: _vm.chartid,
                  ygrid: 3
                },"width":280,"height":150},on:{"generated":_vm.setLegend}})],1):_vm._e(),(_vm.legend)?_c('div',{staticClass:"chart__legend",domProps:{"innerHTML":_vm._s(_vm.legend)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }